import React from 'react';
import { useAppSelector } from 'src/redux/hooks';
import { selectLearningPathwayById } from 'src/redux/slices/learningPathways';
import { AppState } from 'src/redux/store';
import { useClientId, UNGATED_CLIENT_ID } from 'src/contexts/ClientContext';
import LearningPathwayPageHeader from './pageHeader';
import LearningPathwayAccordion from './moduleSectionAccordion';

export interface LearningPathwayProps {
  learningPathwayId: string
  onModuleSelect: (moduleId: string) => void
}

const LearningPathway = ({ learningPathwayId, onModuleSelect }: LearningPathwayProps) => {
  // Get the learning pathway data from Redux store
  const pathway = useAppSelector(
    (state: AppState) => selectLearningPathwayById(state, learningPathwayId),
  );

  const clientId = useClientId();
  // Ungated users use static (non-localized) content; gated users get pre-localized PolyD content.
  const isLocalized = clientId !== UNGATED_CLIENT_ID;

  return (
    <>
      <LearningPathwayPageHeader
        title={pathway.data.title}
        description={pathway.data.description}
        imageSrc={pathway.data.imageSrc}
        stats={pathway.data.learningPathwayStats}
        isLocalized={isLocalized}
      />

      <LearningPathwayAccordion
        sections={pathway.data.sections}
        onModuleSelect={onModuleSelect}
        isLocalized={isLocalized}
      />
    </>
  );
};

export default LearningPathway;
